<template>
  <div class="cooperation-page">
    <div class="main-content">
      <!-- 英雄区 -->
      <section class="hero-section">
        <div class="container">
          <AppHeader />
          <div class="hero-content" ref="heroContent">
            <h1 class="hero-title animate-scroll">商务合作</h1>
            <h2 class="hero-subtitle animate-scroll">合作共赢，共创辉煌</h2>
          </div>
        </div>
      </section>

      <!-- 合作表单区 -->
      <section class="cooperation-section" ref="cooperationSection">
        <div class="container">
          <div class="forms-container animate-scroll">
            <!-- 左侧表单 -->
            <div class="form-wrapper">
              <h2 class="section-title animate-scroll">合作咨询</h2>
              <div class="form-container">
                <form @submit.prevent="submitForm" class="cooperation-form">
                  <div class="form-row">
                    <div class="form-group">
                      <label for="name">姓名 *</label>
                      <input 
                        type="text" 
                        id="name" 
                        v-model="formData.name" 
                        required 
                        placeholder="请输入您的姓名"
                      >
                    </div>
                    <div class="form-group">
                      <label for="phone">手机号 *</label>
                      <input 
                        type="tel" 
                        id="phone" 
                        v-model="formData.phone" 
                        required 
                        placeholder="请输入您的手机号"
                        pattern="^1[0-9]{10}$"
                        maxlength="11"
                        @input="validatePhone"
                      >
                    </div>
                  </div>
                  
                  <div class="form-row">
                    <div class="form-group">
                      <label for="company">公司名称 *</label>
                      <input 
                        type="text" 
                        id="company" 
                        v-model="formData.company" 
                        required 
                        placeholder="请输入您的公司名称"
                      >
                    </div>
                    <div class="form-group">
                      <label for="email">联系人邮箱</label>
                      <input 
                        type="email" 
                        id="email" 
                        v-model="formData.email" 
                        placeholder="请输入您的邮箱地址"
                      >
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="contents">合作描述 *</label>
                    <textarea 
                      id="contents" 
                      v-model="formData.contents" 
                      required 
                      placeholder="请详细描述您的合作需求"
                      rows="6"
                    ></textarea>
                  </div>
                  <div class="form-actions">
                    <button type="submit" class="submit-btn" :disabled="submitting">
                      {{ submitting ? '提交中...' : '提交合作申请' }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
            
            <!-- 右侧表单 -->
            <div class="form-wrapper">
              <h2 class="section-title animate-scroll">律师合作</h2>
              <div class="form-container">
                <form @submit.prevent="submitForm2" class="cooperation-form">
                  <div class="form-row">
                    <div class="form-group">
                      <label for="name2">姓名 *</label>
                      <input 
                        type="text" 
                        id="name2" 
                        v-model="formData2.name" 
                        required 
                        placeholder="请输入您的姓名"
                      >
                    </div>
                    <div class="form-group">
                      <label for="phone2">手机号 *</label>
                      <input 
                        type="tel" 
                        id="phone2" 
                        v-model="formData2.phone" 
                        required 
                        placeholder="请输入您的手机号"
                        pattern="^1[0-9]{10}$"
                        maxlength="11"
                        @input="validatePhone2"
                      >
                    </div>
                  </div>
                  
                  <div class="form-row">
                    <div class="form-group">
                      <label for="company2">律所名称 *</label>
                      <input 
                        type="text" 
                        id="company2" 
                        v-model="formData2.company" 
                        required 
                        placeholder="请输入您的律所名称"
                      >
                    </div>
                    <div class="form-group">
                      <label for="email2">联系人邮箱</label>
                      <input 
                        type="email" 
                        id="email2" 
                        v-model="formData2.email" 
                        placeholder="请输入您的邮箱地址"
                      >
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="contents2">合作描述 *</label>
                    <textarea 
                      id="contents2" 
                      v-model="formData2.contents" 
                      required 
                      placeholder="请详细描述您的合作需求"
                      rows="6"
                    ></textarea>
                  </div>
                  <div class="form-actions">
                    <button type="submit" class="submit-btn" :disabled="submitting2">
                      {{ submitting2 ? '提交中...' : '提交合作申请' }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="footer-wrapper">
      <AppFooter />
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue';
import AppFooter from '@/components/AppFooter.vue';
import { submitCooperate, uploadFile, getAreaList } from '@/api';

export default {
  name: 'CooperationPage',
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      formData: {
        name: '',
        phone: '',
        company: '',
        email: '',
        contents: '',
        type: 1,
      },
      submitting: false,
      heroObserver: null,
      cooperationObserver: null,
      uploadedFiles: [],
      areaData: {
        provinces: [],
        cities: [],
        districts: []
      },
      formData2: {
        name: '',
        phone: '',
        company: '',
        email: '',
        contents: '',
        type: 2,
      },
      submitting2: false
    }
  },
  created() {
    this.fetchProvinces();
  },
  mounted() {
    this.$nextTick(() => {
      // 头部动画
      const header = this.$el.querySelector('.logo-area.animate-scroll');
      if (header) header.classList.add('visible');
      const bar = this.$el.querySelector('.logo-bar.animate-scroll');
      if (bar) bar.classList.add('visible');
      
      // 英雄区动画
      const heroContent = this.$refs.heroContent;
      if (heroContent) {
        this.heroObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const heroEls = entry.target.querySelectorAll('.animate-scroll');
              heroEls.forEach((el, idx) => {
                setTimeout(() => {
                  el.classList.add('visible');
                }, idx * 120);
              });
            }
          });
        }, { threshold: 0.1 });
        this.heroObserver.observe(heroContent);
      }

      // 合作表单区动画
      const cooperationSection = this.$refs.cooperationSection;
      if (cooperationSection) {
        this.cooperationObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const els = entry.target.querySelectorAll('.animate-scroll');
              els.forEach((el, idx) => {
                setTimeout(() => {
                  el.classList.add('visible');
                }, idx * 120);
              });
            }
          });
        }, { threshold: 0.1 });
        this.cooperationObserver.observe(cooperationSection);
      }
    });
  },
  beforeUnmount() {
    if (this.heroObserver) {
      this.heroObserver.disconnect();
    }
    if (this.cooperationObserver) {
      this.cooperationObserver.disconnect();
    }
  },
  methods: {
    async fetchProvinces() {
      try {
        const res = await getAreaList();
        if (res && res.data) {
          this.areaData.provinces = res.data;
        }
      } catch (error) {
        console.error('获取省份列表失败:', error);
      }
    },
    async fetchCities(provinceId) {
      try {
        const res = await getAreaList({ province: provinceId });
        if (res && res.data) {
          this.areaData.cities = res.data;
        }
      } catch (error) {
        console.error('获取城市列表失败:', error);
      }
    },
    async fetchDistricts(cityId) {
      try {
        const res = await getAreaList({ 
          province: this.formData.province, 
          city: cityId 
        });
        if (res && res.data) {
          this.areaData.districts = res.data;
        }
      } catch (error) {
        console.error('获取区县列表失败:', error);
      }
    },
    onProvinceChange() {
      this.formData.city = '';
      this.formData.district = '';
      this.areaData.cities = [];
      this.areaData.districts = [];
      if (this.formData.province) {
        this.fetchCities(this.formData.province);
      }
    },
    onCityChange() {
      this.formData.district = '';
      this.areaData.districts = [];
      if (this.formData.city) {
        this.fetchDistricts(this.formData.city);
      }
    },
    async uploadSingleFile(file) {
      try {
        const res = await uploadFile(file);
        if (res && res.code === 1 && res.data) {
          return res.data.fullurl;
        }
        throw new Error('文件上传失败');
      } catch (error) {
        console.error('文件上传失败:', error);
        throw error;
      }
    },
    formatDateTime(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    async submitForm() {
      if (this.submitting) return;
      
      // 验证手机号格式
      const phoneRegex = /^1[0-9]{10}$/;
      if (!phoneRegex.test(this.formData.phone)) {
        alert('请输入正确的手机号格式');
        return;
      }
      
      this.submitting = true;
      try {
        // 先上传所有文件
        // const uploadPromises = this.uploadedFiles.map(fileObj => 
        //   this.uploadSingleFile(fileObj.file)
        // );
        
        // const uploadedUrls = await Promise.all(uploadPromises);
        
        // 设置提交时间，格式化为可视化时间
        // this.formData.submit_time = this.formatDateTime(new Date());
        
        // 准备提交数据
        const submitData = {
          ...this.formData,
          // upload_files: uploadedUrls.join(',')
        };
        
        const res = await submitCooperate(submitData);
        if (res && res.code === 1) {
          alert('提交成功！我们会尽快与您联系。');
          this.resetForm();
        } else {
          alert('提交失败，请稍后重试。');
        }
      } catch (error) {
        console.error('提交合作申请失败:', error);
        alert('提交失败，请稍后重试。');
      } finally {
        this.submitting = false;
      }
    },
    async submitForm2() {
      if (this.submitting2) return;
      
      // 验证手机号格式
      const phoneRegex = /^1[0-9]{10}$/;
      if (!phoneRegex.test(this.formData2.phone)) {
        alert('请输入正确的手机号格式');
        return;
      }
      
      this.submitting2 = true;
      try {
        // 准备提交数据
        const submitData = {
          ...this.formData2,
        };
        
        const res = await submitCooperate(submitData);
        if (res && res.code === 1) {
          alert('提交成功！我们会尽快与您联系。');
          this.resetForm2();
        } else {
          alert('提交失败，请稍后重试。');
        }
      } catch (error) {
        console.error('提交合作申请失败:', error);
        alert('提交失败，请稍后重试。');
      } finally {
        this.submitting2 = false;
      }
    },
    resetForm() {
      this.formData = {
        name: '',
        phone: '',
        company: '',
        email: '',
        contents: '',
        // upload_files: '',
        // province: '',
        // city: '',
        // district: '',
        // submit_time: ''
      };
      this.uploadedFiles = [];
      this.areaData.cities = [];
      this.areaData.districts = [];
      // 清空文件输入框
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    },
    resetForm2() {
      this.formData2 = {
        name: '',
        phone: '',
        company: '',
        email: '',
        contents: '',
      };
    },
    validatePhone() {
      // 只保留数字
      this.formData.phone = this.formData.phone.replace(/\D/g, '');
      
      // 如果第一位不是1，清空输入
      if (this.formData.phone.length > 0 && this.formData.phone[0] !== '1') {
        this.formData.phone = '';
      }
      
      // 限制最多11位
      if (this.formData.phone.length > 11) {
        this.formData.phone = this.formData.phone.slice(0, 11);
      }
    },
    validatePhone2() {
      // 只保留数字
      this.formData2.phone = this.formData2.phone.replace(/\D/g, '');
      
      // 如果第一位不是1，清空输入
      if (this.formData2.phone.length > 0 && this.formData2.phone[0] !== '1') {
        this.formData2.phone = '';
      }
      
      // 限制最多11位
      if (this.formData2.phone.length > 11) {
        this.formData2.phone = this.formData2.phone.slice(0, 11);
      }
    },
    handleFileChange(event) {
      const files = event.target.files;
      const maxSize = 10 * 1024 * 1024; // 10MB
      const allowedTypes = ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png', '.gif'];
      
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        
        // 检查文件大小
        if (file.size > maxSize) {
          alert(`文件 ${file.name} 超过10MB限制，请选择更小的文件。`);
          continue;
        }
        
        // 检查文件类型
        const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
        if (!allowedTypes.includes(fileExtension)) {
          alert(`文件 ${file.name} 格式不支持，请选择 PDF、Word 或图片格式的文件。`);
          continue;
        }
        
        // 检查是否重复
        const isDuplicate = this.uploadedFiles.some(existingFile => 
          existingFile.name === file.name && existingFile.size === file.size
        );
        
        if (isDuplicate) {
          alert(`文件 ${file.name} 已存在，请选择其他文件。`);
          continue;
        }
        
        this.uploadedFiles.push({
          name: file.name,
          size: file.size,
          file: file // 保存原始文件对象，用于后续上传
        });
      }
      
      // 清空input值，允许重复选择同一文件
      event.target.value = '';
    },
    triggerFileUpload() {
      this.$refs.fileInput.click();
    },
    removeFile(index) {
      this.uploadedFiles.splice(index, 1);
    },
    formatFileSize(size) {
      if (size < 1024) {
        return size + ' B';
      } else if (size < 1024 * 1024) {
        return (size / 1024).toFixed(2) + ' KB';
      } else {
        return (size / (1024 * 1024)).toFixed(2) + ' MB';
      }
    }
  }
}
</script>

<style scoped>
.cooperation-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: Arial, sans-serif;
  background: #fff;
}
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #F8F8F8;
}
.footer-wrapper {
  flex-shrink: 0;
}

.hero-section {
  width: 1920px;
  height: 600px;
  background-image: url('~@/assets/image/joinUsBg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}
.container {
  width: 1200px;
  margin: 0 auto;
  position: relative;
}
.hero-content {
  margin-top: 302px;
  color: #fff;
}
.hero-title {
  font-size: 40px;
  font-weight: 600;
  line-height: 56px;
  margin: 0;
}
.hero-subtitle {
  font-size: 26px;
  line-height: 37px;
  margin-top: 10px;
  font-weight: 400;
}

.cooperation-section {
  width: 1920px;
  background: #F8F8F8;
  min-height: 600px;
  padding: 60px 0;
}
.section-title {
  font-size: 36px;
  font-weight: 600;
  color: #333;
  margin-bottom: 40px;
  line-height: 50px;
}
.forms-container {
  display: flex;
  gap: 24px;
  width: 100%;
  margin: 0;
}
.form-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.form-container {
  flex: 1;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  padding: 40px;
}
.cooperation-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.form-row {
  display: flex;
  gap: 24px;
}
.form-group {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.form-group label {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}
.form-group input,
.form-group textarea,
.form-group select {
  padding: 12px 16px;
  border: 1px solid #E0E0E0;
  border-radius: 6px;
  font-size: 16px;
  transition: border-color 0.3s;
}
.form-group input:focus,
.form-group textarea:focus,
.form-group select:focus {
  outline: none;
  border-color: #3159B3;
}
.form-group textarea {
  resize: vertical;
  min-height: 120px;
}
.form-group select:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}
.form-actions {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.submit-btn {
  background: #3159B3;
  color: #fff;
  border: none;
  padding: 16px 48px;
  font-size: 18px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.submit-btn:hover:not(:disabled) {
  background: #2A4A9B;
}
.submit-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

/* 文件上传样式 */
.file-upload-area {
  margin-top: 8px;
}
.upload-trigger {
  border: 2px dashed #E0E0E0;
  border-radius: 8px;
  padding: 32px 16px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.3s, background-color 0.3s;
}
.upload-trigger:hover {
  border-color: #3159B3;
  background-color: #f8f9fa;
}
.upload-icon {
  font-size: 32px;
  color: #999;
  margin-bottom: 8px;
}
.upload-text {
  font-size: 16px;
  color: #333;
  margin-bottom: 4px;
}
.upload-hint {
  font-size: 14px;
  color: #999;
}
.file-list {
  margin-top: 16px;
}
.file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #f8f9fa;
  border-radius: 6px;
  margin-bottom: 8px;
}
.file-info {
  flex: 1;
}
.file-name {
  font-size: 14px;
  color: #333;
  margin-bottom: 4px;
}
.file-size {
  font-size: 12px;
  color: #999;
}
.file-actions {
  margin-left: 16px;
}
.remove-btn {
  background: #ff4757;
  color: #fff;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.3s;
}
.remove-btn:hover {
  background: #ff3742;
}

/* 动画样式 */
.animate-scroll {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 1s cubic-bezier(.4,0,.2,1), transform 1s cubic-bezier(.4,0,.2,1);
}
.animate-scroll.visible {
  opacity: 1;
  transform: translateY(0);
}
</style> 
